module.exports = __webpack_public_path__ + "img/3.32a1c03e.jpg";